// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1p4wk","header":"MergedInvoice_header__1Fccq"};